import { defineComponent as t, openBlock as n, createBlock as l, unref as c, mergeProps as p, withCtx as i, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconCircle",
  __name: "IconCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (s, e) => (n(), l(c(m), p(r, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
